import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NavTarget } from 'app/shared/components/link/link.component';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { NeskoAbVerteilerDetailEntryMeta } from 'app/core/amtlichebewertung-api';
import { AppPermissionService } from '../../../core/services/app-permission.service';
import { LinkComponent } from '../../components/link/link.component';
import { NgTemplateOutlet } from '@angular/common';
import { NeskoabGrundstuecknummerPipe } from './neskoab-grundstuecknummer.pipe';

@Component({
  selector: 'cap-kompakt-neskoab-grundstueck',
  templateUrl: './kompakt-neskoab-grundstueck.component.html',
  styleUrls: ['./kompakt-neskoab-grundstueck.component.scss'],
  imports: [LinkComponent, NgTemplateOutlet, NeskoabGrundstuecknummerPipe]
})
export class KompaktNeskoabGrundstueckComponent implements OnInit, OnDestroy {
  navTargets = NavTarget;

  isSpezialGrundstueckOnlyAvailableInNESKOAB = false;
  hasPermissionForSpezialGrundstueck = false;

  @Input()
  item: NeskoAbVerteilerDetailEntryMeta;

  @Input()
  canNavigate = true;

  protected language: string;

  private subscription: Subscription;

  constructor(
    private permissionService: AppPermissionService,
    private translateService: TranslateService
  ) {
    this.subscription = this.translateService.onLangChange.subscribe((language) => {
      this.language = language.lang;
    });
  }

  ngOnInit() {
    this.isSpezialGrundstueckOnlyAvailableInNESKOAB = this.item.nummer !== undefined && +this.item.nummer >= 80000;
    this.hasPermissionForSpezialGrundstueck = this.permissionService.hasPermission('ANZEIGE_SPEZNESKO_GRUNDSTUECK');
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
